import DOMPurify from "dompurify";
import styles from "./PolicyHtmlContent.module.css";

interface PolicyHtmlContentProps {
  html: string;
}

export default function PolicyHtmlContent({
  html,
}: PolicyHtmlContentProps): JSX.Element {
  const sanitized = DOMPurify.sanitize(html);

  return (
    <div
      className={styles.content}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
}
